import {Component, Inject, OnInit} from '@angular/core';
import {Localiser} from "../../../services/localiser";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {LuminariaService} from "../../../services/luminaria.service";
import {SensorService} from "../../../services/sensor.service";
import {ConcentradorService} from "../../../services/concentrador.service";
import {from} from "rxjs";
import {concatMap, toArray} from "rxjs/operators";

@Component({
  selector: 'app-delete',
  templateUrl: './delete.component.html',
  styleUrls: ['./delete.component.css']
})
export class DeleteComponent implements OnInit {

  constructor(public localiser: Localiser, public dialogRef: MatDialogRef<DeleteComponent>,
              @Inject(MAT_DIALOG_DATA) public data: {type, device},
              private luminariaService: LuminariaService, private sensorService: SensorService,
              private concentradorService: ConcentradorService) { }

  type = undefined;
  device = undefined;
  devices = [];

  deleteLumRegistry: boolean = false;
  deleteLumFull: boolean = false;
  deleteGW: boolean = false;
  deleteSensor: boolean = false;

  deleting = false;

  ngOnInit(): void {
    this.type = this.data.type;
    this.device = this.data.device;
    this.devices = this.data.device;
    if (this.type == undefined || this.device == undefined) {
      this.onCancelClick();
    }
  }

  isLuminaryBatchDelete() {
    return this.type == 'lum-batch';
  }

  getBatchDeleteCount() {
    return Array.isArray(this.devices) ? this.devices.length : 0;
  }

  changeRegistryDelete() {
    this.deleteLumRegistry = true;
  }

  changeFullDelete() {
    this.deleteLumFull = true;
  }

  changeGWDelete() {
    this.deleteGW = true;
  }

  changeSensorDelete() {
    this.deleteSensor = true;
  }

  goBack() {
    this.deleteLumRegistry = false;
    this.deleteLumFull = false;
    this.deleteGW = false;
    this.deleteSensor = false;
  }

  confirmDelete() {
    this.deleting = true;
    if (this.deleteLumRegistry) {
      if (this.isLuminaryBatchDelete()) {
        this.deleteLuminariesBatch('registry');
      } else {
        this.luminariaService.deleteRegistry(this.device.idDispositivo).subscribe(result => {
          this.dialogRef.close(true);
        })
      }
    } else if (this.deleteLumFull) {
      if (this.isLuminaryBatchDelete()) {
        this.deleteLuminariesBatch('full');
      } else {
        this.luminariaService.deleteFull(this.device.idDispositivo).subscribe(result => {
          this.dialogRef.close(true);
        })
      }
    } else if (this.deleteGW) {
      this.concentradorService.delete(this.device.idDispositivo).subscribe(result => {
        this.dialogRef.close(true);
      })
    } else if (this.deleteSensor) {
      this.sensorService.deleteRegistry(this.device.idLuminaria).subscribe(result => {
        this.dialogRef.close(true);
      })
    }
  }

  deleteLuminariesBatch(mode: string) {
    from(this.devices).pipe(
      concatMap((luminary: any) => mode == 'registry'
        ? this.luminariaService.deleteRegistry(luminary.idDispositivo)
        : this.luminariaService.deleteFull(luminary.idDispositivo)),
      toArray()
    ).subscribe({
      next: () => {
        this.dialogRef.close(true);
      },
      error: () => {
        this.deleting = false;
      }
    });
  }

  onCancelClick(): void {
    this.dialogRef.close();
  }

}
